import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { Store } from '@ngrx/store';
import { selectAuthMessage, selectDealerProfile } from 'src/app/common/store/state/app.state';

import { AuthActions } from 'src/app/common/store/actions/auth.actions';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';

import { MatDialog } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { DealerEditDialogComponent } from '../../dealer/dealer-edit/dealer-edit.component';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';
import { Country } from 'src/app/public/common/models/country.model';

@Component({
    selector: 'app-customer-dashboard',
    templateUrl: './customer-dashboard.component.html',
    styleUrls: ['./customer-dashboard.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CustomerDashboardComponent implements OnInit {

  dealerData = new Dealer();

  showDetails: boolean = false;

  myProfile$: Observable<Dealer>;
  authFeedback$: Observable<string>;
  
  sessionInfo = "Click to update data";

  passwordRecoverForm: FormGroup = new FormGroup({
    oldPassword: new FormControl('', Validators.required),
    newPassword: new FormControl('', Validators.required),
  });


  constructor(
    private store: Store, 
    public dialog: MatDialog, 

    private route: ActivatedRoute) {
      this.myProfile$ = this.store.select(selectDealerProfile);
      this.authFeedback$ = store.select(selectAuthMessage);
    }
  
  ngOnInit(): void {

    this.myProfile$.subscribe( (dealer: Dealer) => {
      this.dealerData = dealer;
    }

    );
  } 

  openDealerEditDialog(): void {

    const dialogRef = this.dialog.open(DealerEditDialogComponent, {
      data: Object.assign(new Dealer(), this.dealerData)
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      //console.log('New price = '+result+ " car Id = "+carId);
      if(result != undefined ){
        console.log(result)
        this.store.dispatch(DealerActions.updateDealerProfileSubmit( { dlUpdates: result }));

      }
        
    });

  }

  refreshMessages(){
    //this.store.dispatch(MessageActions.fetchMessagesSubmit());
  }

  submitPasswordUpdateForm(){

    this.store.dispatch(AuthActions.updatePasswordSubmit({
      oldPassword: this.passwordRecoverForm.value.oldPassword,
      newPassword: this.passwordRecoverForm.value.newPassword
    }));

  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

  getCountryByCode(code: string): Country{
    return GeneralBasicData.getCountryByCode(code)!;
  }

  getRatingsTotalCount(): number{
    return AppFunctions.getArraySum(this.dealerData.ratingsSummary.counts)
  }

}   

  
